var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedTellFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9999 8C16.9999 12.4183 13.4182 16 8.99988 16C7.20353 16 5.54545 15.4079 4.21016 14.4083L0.597168 15.6788L2.04303 11.9528C1.37913 10.7868 0.999885 9.43769 0.999885 8C0.999885 3.58172 4.58161 0 8.99988 0C13.4182 0 16.9999 3.58172 16.9999 8ZM5.75 9C6.30228 9 6.75 8.55229 6.75 8C6.75 7.44772 6.30228 7 5.75 7C5.19772 7 4.75 7.44772 4.75 8C4.75 8.55229 5.19772 9 5.75 9ZM10 8C10 8.55229 9.55229 9 9 9C8.44772 9 8 8.55229 8 8C8 7.44772 8.44772 7 9 7C9.55229 7 10 7.44772 10 8ZM12.25 9C12.8023 9 13.25 8.55229 13.25 8C13.25 7.44772 12.8023 7 12.25 7C11.6977 7 11.25 7.44772 11.25 8C11.25 8.55229 11.6977 9 12.25 9Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedTellFilledIcon);
export default __webpack_public_path__ + "static/media/DeprecatedTellFilledIcon.e7305d091083ebf26afbcae8fb7cddc9.svg";
export { ForwardRef as ReactComponent };